import toReadableLabel from 'src/shared/utils/toReadableLabel';

import { cn } from 'src/shared/components/ui';

import { Tag } from '../ui';

const TASK_TAG_COLORS = {
  'in-progress': 'in-progress',
  'action-required': 'action-required',
  'new-update': 'new-update',
  'user-question': 'user-question',
  task: 'primary',
  none: 'none',
  completed: 'completed',
  // V2 Update Statuses
  action: 'action',
  'from-you': 'from-you',
  resolved: 'resolved',
  update: 'update',
  question: 'action'
} as const;

interface TaskStatusTagProps {
  type: keyof typeof TASK_TAG_COLORS;
  label?: string;
  className?: string;
}

const TaskStatusTag: React.FC<TaskStatusTagProps> = ({
  type,
  label,
  className
}) => {
  return (
    <Tag
      radius="full"
      className={cn('capitalize', className)}
      color={TASK_TAG_COLORS?.[type] || 'none'}
    >
      <div className="flex items-center justify-center gap-1">
        {label ?? toReadableLabel(type)}
      </div>
    </Tag>
  );
};

export default TaskStatusTag;
